"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOI4 = void 0;
var GameInfo_1 = require("./GameInfo");
/**
 * GameInfo for Hearts of Iron IV
 */
exports.HOI4 = {
    Name: 'Hearts of Iron IV',
    Extension: '.hoi4',
    Compressed: GameInfo_1.CompressMode.Unzipped,
    MagicNumber: Buffer.from('HOI4bin'),
    MagicString: 'HOI4txt',
    Dictionary: {},
    FormatRules: [],
    InitiateParser: function () { return; }
};
exports.default = exports.HOI4;
